<ion-header
  class="ion-no-border"
  [ngClass]="
    platformType !== platformEnum.desktop
      ? platformType === platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="platformType === platformEnum.desktop" slot="end">
      <ion-button
        id="close-modal-btn"
        data-cy="close-extended-cost-report-modal-button"
        (click)="dismiss()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label
      *ngIf="platformType !== platformEnum.desktop"
      class="bold title"
      data-cy="extended-cost-report-label"
    >
      {{ 'i18n.inventory.downloadExtendedCostReportTitle' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    platformType !== platformEnum.desktop
      ? platformType === platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <ion-grid>
    <ion-row *ngIf="platformType === platformEnum.desktop">
      <ion-col size="12" class="bold title">
        <p>
          {{ 'i18n.inventory.downloadExtendedCostReportTitle' | translate }}
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="main-message">
        <p>
          {{ 'i18n.inventory.extendedCostReport.main1' | translate }}
          <span class="bold">
            {{ 'i18n.inventory.extendedCostReport.main2' | translate }}</span
          >{{ 'i18n.inventory.extendedCostReport.main3' | translate }}
          <span class="bold">
            {{ 'i18n.inventory.extendedCostReport.main4' | translate }}</span
          >
          {{ 'i18n.inventory.extendedCostReport.main5' | translate }}
        </p>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" class="warning-message">
        <ion-icon name="alert-circle-outline"></ion-icon>
        <p>
          {{ 'i18n.inventory.extendedCostReport.warn1' | translate
          }}<span class="bold">
            {{ 'i18n.inventory.extendedCostReport.warn2' | translate }}</span
          >
          {{ 'i18n.inventory.extendedCostReport.warn3' | translate }}
        </p>
      </ion-col>
    </ion-row>
    <ion-row class="calendar">
      <ion-col size="12">
        <app-calendar-v2
          [maxLimit]="limit"
          [maxRange]="range"
          [multiSelectMode]="selectMode"
          [platform]="platformType"
          (rangeEmit)="handleRangeSelection($event)"
        >
        </app-calendar-v2>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platformType !== platformEnum.mobile"
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="cancel-extended-cost-report-modal-button"
        [ngClass]="
          platformType !== platformEnum?.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        data-cy="extended-cost-report-modal-button"
        [ngClass]="
          platformType !== platformEnum.mobile
            ? dateRange.length === 0
              ? 'usf-fill-disabled-dsktp-tblt-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
            : dateRange.length === 0
            ? 'usf-fill-disabled-mobile-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="submit()"
      >
        {{ 'i18n.common.download' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
